// extracted by mini-css-extract-plugin
export default {"image":"carousel_image__-uuL-","custom":"carousel_custom__Xh+Iw","container":"carousel_container__wde3C"};